import { render, staticRenderFns } from "./SimplePanelComponent.vue?vue&type=template&id=550047b2&"
import script from "./SimplePanelComponent.vue?vue&type=script&lang=js&"
export * from "./SimplePanelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports